export default "/images/dashboard.svg?d29690fe349be444f797cd25dc719d73";